<script setup>
import store from "../../store";
import {computed, onMounted, ref} from "vue";

const emits = defineEmits(['selected'])
const props = defineProps({
  value: String,
  withLocal: Boolean,
  useEvent: Boolean,
  large: Boolean,
  tabs: Boolean
})

const extensionDetected = ref(false);

const links = computed(() => {
  if (props.withLocal)
    return {
      OMS: '/item?q=',
      ...store.state.settings.defaults.research_urls
    }
  else
    return store.state.settings.defaults.research_urls
})

const click = (url) => {
  if (extensionDetected.value) {
    new Promise((resolve, reject) => {
      const onRes = (e) => {
        if (e.source !== window) return;
        if (e.data?.type === "ntc-research/response") {
          window.removeEventListener("message", onRes);
          e.data.ok ? resolve() : reject(new Error(e.data.error || "unknown error"));
        }
      };
      window.addEventListener("message", onRes);
      window.postMessage({type: "ntc-research/request", q: props.value, mode: props.tabs ? 'reuse' : 'newWindow'}, "*");
      setTimeout(() => {
        window.removeEventListener("message", onRes);
        reject(new Error("timeout"));
      }, 2000);
    });
  } else {
    if (props.value)
      if (props.useEvent)
        emits('selected', links.value[url] + props.value)
      else
        window.open(links.value[url] + props.value, 'research')
  }
}


async function detect() {
  extensionDetected.value = await new Promise((resolve) => {
    let done = false;
    const onAck = (e) => {
      if (e.source !== window) return;
      if (e.data?.type === "ntc-research/ack") {
        done = true;
        window.removeEventListener("message", onAck);
        resolve(true);
      }
    };
    window.addEventListener("message", onAck);
    window.postMessage({type: "ntc-research/ping"}, "*");
    setTimeout(() => {
      if (!done) {
        window.removeEventListener("message", onAck);
        resolve(false);
      }
    }, 300);
  });
}

onMounted(detect)

defineExpose({
  research: () => {
    if (extensionDetected.value)
      click()
  }
})

</script>

<template>
  <b-btn v-if="extensionDetected" @click="click()" :variant="large ? 'outline-primary' : 'link'" size="sm">
    <template v-if="large">Research</template>
    <font-awesome-icon :icon="['fas', 'book-atlas']" v-else/>
  </b-btn>
  <b-dropdown v-else size="sm" v-bind="$attrs" :text="large ? 'Research' : 'undefined'"
              :variant="large ? 'outline-primary' : undefined">
    <template #button-content v-if="!large">
      <font-awesome-icon :icon="['fas', 'book-atlas']"/>
    </template>
    <b-dropdown-item v-for="key in Object.keys(links)" :key="key" @click.stop="click(key)">
      <div class="d-flex h-100">
        <div class="flex-fill">
          <div>{{ key }}</div>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<style scoped>

</style>